import React from 'react';
import PropTypes from 'prop-types';

class Pane extends React.Component {
  render() {
    return (
      <div style={this.props.style}>
        {this.props.children}
      </div>
    );
  }
}

Pane.propTypes = {
  label: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.element,
  ]).isRequired,
  children: PropTypes.element.isRequired,
};

export default Pane;



// WEBPACK FOOTER //
// ./src/components/shared/Pane.js